import * as React from 'react'
import { CartDrawer } from '@components/CartDrawer/CartDrawer'
// import CartIcon from '@icons/cart'
import { StoreContext } from '@context/store-context'
import { CgShoppingBag } from 'react-icons/cg'
import './CartButton.less'

export function CartButton({ quantity }) {
  const { setShowCartDrawer } = React.useContext(StoreContext)

  const drawerShow = () => setShowCartDrawer(true)

  return (
    <React.Fragment>
      <button className="cart-button ml-3" onClick={drawerShow}>
        <CgShoppingBag className="text-fluid-md" />
        {quantity > 0 && <div className="badge">{quantity}</div>}
      </button>
      <CartDrawer />
    </React.Fragment>
  )
}
